module.exports = "<p>\n  Le week-end, la restauration est possible chez vous ou au restaurant (sur réservation uniquement).\n</p>\n<p>\n Retrouver <a href=\"http://festyrepasduloup.com/\">mon activité de chef à domicile. </a>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/repas-groupes/repas-groupes.component.html
// module id = 599
// module chunks = 1